import {
  GET_FOREIGN_TRAVEL_REQUEST,
  GET_FOREIGN_TRAVEL_SUCCESS,
  GET_FOREIGN_TRAVEL_FAIL,
  UPDATE_FOREIGN_TRAVEL_STATUS,
} from "../constants/foreignTravelConstants";

const initialState = {
  requests: [],
  loading: false,
  error: null,
};

export const foreignTravelReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FOREIGN_TRAVEL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_FOREIGN_TRAVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        requests: action.payload,
        error: null,
      };
    case GET_FOREIGN_TRAVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_FOREIGN_TRAVEL_STATUS:
      return {
        ...state,
        requests: state.requests.map((req) =>
          (req.id && req.id === action.payload.id) ||
          (req.REF_NO && req.REF_NO === action.payload.refNo) ||
          (req.SERVICE_NO && req.SERVICE_NO === action.payload.serviceNo && req.DEPS === action.payload.rawApiData?.DEPS)
            ? action.payload
            : req
        ),
      };
    default:
      return state;
  }
};

export default foreignTravelReducer;
